export default "__VITE_ASSET__d925e220__"